/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RelationalTableRegistrationCreateRequest { 
    /**
     * The Namespace to which a Business Object Format is related
     */
    namespace: string;
    /**
     * The name of the Business Object Definition to which a Business Object Format is related
     */
    businessObjectDefinitionName: string;
    /**
     * The display name of the business object definition                
     */
    businessObjectDefinitionDisplayName?: string;
    /**
     * The Usage of this Business Object Format - a string describing how this format is used. Often used as a label for the Business                   Object Format                
     */
    businessObjectFormatUsage: string;
    /**
     * The name of the data provider
     */
    dataProviderName: string;
    /**
     * The relational schema name. A schema name must match the actual schema name as it is stored in the relational database                
     */
    relationalSchemaName: string;
    /**
     * The relational table name. A table name must match the actual table name as it is stored in the relational database                
     */
    relationalTableName: string;
    /**
     * The name of the storage
     */
    storageName: string;
}
